import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';

const PaymentSuccess = () => {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.close();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 px-6" data-testid="payment-success">
            <div className="text-center max-w-sm">
                <div className="relative mx-auto w-24 h-24 mb-8">
                    <div className="absolute inset-0 rounded-full bg-green-500/20 animate-ping" style={{ animationDuration: '2s' }} />
                    <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-green-500/10 border-2 border-green-500/40">
                        <CheckCircle2 size={48} className="text-green-400" strokeWidth={1.5} />
                    </div>
                </div>

                <h1 className="text-3xl font-bold text-white mb-3">Paiement r&eacute;ussi</h1>
                <p className="text-slate-400 mb-2">Votre paiement a &eacute;t&eacute; trait&eacute; avec succ&egrave;s.</p>
                <p className="text-slate-400 text-sm mb-8">Merci pour votre confiance.</p>

                <div className="glass-card p-4 inline-block">
                    <p className="text-slate-500 text-xs">
                        Fermeture automatique dans <span className="text-white font-bold">{countdown}s</span>
                    </p>
                </div>

                <div className="mt-6">
                    <button
                        onClick={() => window.close()}
                        className="text-sm text-slate-500 hover:text-white transition-colors underline underline-offset-4"
                    >
                        Fermer maintenant
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
